import { createStore } from '@direct-frontend/modules-store';

export const productStore = createStore('entities/product');
